import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MoveToInboxAddTicketSubject = ({
  subject,
  setSubject
}) => {
  const handleSubjectOnChange = useCallback(evt => setSubject(evt.target.value), [setSubject]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.moveToInboxPrompt.ticketSubjectTitle"
    }),
    required: true,
    marginBlock: "400",
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "move-to-helpdesk-subject-input",
      value: subject,
      onChange: handleSubjectOnChange
    })
  });
};
MoveToInboxAddTicketSubject.displayName = 'MoveToInboxAddTicketSubject';
export default MoveToInboxAddTicketSubject;